import { Controller } from "@hotwired/stimulus"
import { Collapse } from "bootstrap"

export default class extends Controller {
  static targets = ["row", "detailsContent", "totalAmount", "reasonSelect", "otherReasonField"]
  static values = { currency: String }

  connect() {
    this.collapseInstances = this.detailsContentTargets.map(el =>
      new Collapse(el, { toggle: false })
    )
    this.updateAmounts()
    this.updateOtherReasonFields()
  }

  updateAmounts() {
    let total = 0

    this.rowTargets.forEach((row, index) => {
      const price = parseFloat(row.dataset.price)
      const qtyInput = row.querySelector('.return-quantity-input')
      const qty = parseInt(qtyInput.value) || 0
      const amount = price * qty

      row.querySelector('.amount-value').textContent = this.formatMoney(amount)
      total += amount

      const collapse = this.collapseInstances[index]
      if (collapse) {
        qty > 0 ? collapse.show() : collapse.hide()
      }
    })

    this.totalAmountTarget.textContent = this.formatMoney(total)
  }

  updateOtherReasonFields() {
    this.reasonSelectTargets.forEach((select, index) => {
      const otherReasonField = this.otherReasonFieldTargets[index]
      if (otherReasonField) {
        otherReasonField.style.display = select.value === 'other' ? '' : 'none'
      }
    })
  }

  onReasonChange() {
    this.updateOtherReasonFields()
  }

  formatMoney(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: this.currencyValue,
      minimumFractionDigits: 2
    }).format(amount)
  }
}
